module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/mastercard_logo.0d49aab0.svg";